





window.addEventListener("load", (event) => {

  if(document.querySelector('#build-your-own-meal-prep')) {

      // Function to handle protein selection
      const proteinSelect = document.getElementById('protein');
      const proteinOptions = document.querySelectorAll('.protein-options p');
  
      proteinSelect.addEventListener('change', function() {
          // Hide all protein options
          proteinOptions.forEach(option => {
              option.style.display = 'none';
              option.classList.remove('active');
          });
          // Show the selected protein option
          const selectedProtein = proteinSelect.value.replace(/\s+/g, '-');
          const selectedOption = document.getElementById(`option-${selectedProtein}`);
          if (selectedOption) {
              selectedOption.style.display = 'block';
              selectedOption.classList.add('active');
          }
      });
  
      // Function to handle carbohydrate selection
      const carbohydrateSelect = document.getElementById('carbohydrates');
      const carbohydrateOptions = document.querySelectorAll('.carbohydrate-options p');
  
      carbohydrateSelect.addEventListener('change', function() {
          // Hide all carbohydrate options
          carbohydrateOptions.forEach(option => {
              option.style.display = 'none';
              option.classList.remove('active');
          });
          // Show the selected carbohydrate option
          const selectedCarbohydrate = carbohydrateSelect.value.replace(/\s+/g, '-');
          const selectedOption = document.getElementById(`option-${selectedCarbohydrate}`);
          if (selectedOption) {
              selectedOption.style.display = 'block';
              selectedOption.classList.add('active');
          }
      });
  
  
      // Function to handle vegetable selection
      const vegetableSelect = document.getElementById('vegetable');
      const vegetableOptions = document.querySelectorAll('.vegetable-options p');
  
      vegetableSelect.addEventListener('change', function() {
          // Hide all vegetable options
          vegetableOptions.forEach(option => {
              option.style.display = 'none';
              option.classList.remove('active');
          });
          
          // Get the selected vegetable and update the corresponding option to show
          const selectedVegetable = vegetableSelect.value.replace(/\s+/g, '-').replace(/\(All-4\)/g, '(All-4)');
          const selectedOption = document.getElementById(`option-${selectedVegetable}`);
          
          if (selectedOption) {
              selectedOption.style.display = 'block';
              selectedOption.classList.add('active');
          }
        
      });

const checkAllSelectFields = document.querySelectorAll('.product-custom-liquid select');
checkAllSelectFields.forEach(fieldSelect => {
  fieldSelect.addEventListener('change', function() {
    const cstmSelectFields = Array.from(document.querySelectorAll('.line-item-property__field.cstm_chk select'))
      .filter(select => getComputedStyle(select.parentElement).display === 'block');
    
    let totalPrice = 0;
    let totalCalories = 0;
    let totalProtein = 0;
    let totalFat = 0;
    let totalCarbs = 0;
    let totalQuantity = 0; // Initialize total quantity in ounces

    cstmSelectFields.forEach(select => {
      const selectedOption = select.options[select.selectedIndex];
      const priceMatch = selectedOption.text.match(/\$([\d.]+)/);
      const price = priceMatch ? parseFloat(priceMatch[1]) : 0;
      
      // Update total price
      totalPrice += price;
      
      // Get nutritional values from option attributes
      const calories = Number(selectedOption.getAttribute('calories')) || 0;
      const protein = Number(selectedOption.getAttribute('protein')) || 0;
      const fat = Number(selectedOption.getAttribute('fat')) || 0;
      const carbs = Number(selectedOption.getAttribute('carbs')) || 0;
      
      // Extract quantity in Oz from option value (e.g., "4.5 Oz - $0.00")
      const quantityMatch = selectedOption.value.match(/([\d.]+)\s*Oz/i);
      const quantity = quantityMatch ? parseFloat(quantityMatch[1]) : 0;
      totalQuantity += quantity;

      // Log each extracted quantity for debugging
      console.log(`Extracted quantity from option "${selectedOption.value}": ${quantity}`);
      
      // Update total nutritional values
      totalCalories += calories;
      totalProtein += protein;
      totalFat += fat;
      totalCarbs += carbs;
    });

    // Update price display
    let proPrice = Number(document.querySelector('.product-price .product-price--original').getAttribute('data-product-price'));
    const finalPrice = (proPrice + totalPrice).toFixed(2);
    document.querySelector('.product-price .product-price--original').innerText = `$${finalPrice}`;

    // Update nutritional values display
    document.querySelector('.first-values .Protein .value-changes').innerText = totalProtein;
    document.querySelector('.first-values .Carbs .value-changes').innerText = totalCarbs;
    document.querySelector('.first-values .Fats .value-changes').innerText = totalFat;
    document.querySelector('.first-values .Chlories .value-changes').innerText = totalCalories;

    // Update total quantity display with one decimal place
    document.querySelector('.second-value .total-quantity .value-changes').innerText = `${totalQuantity.toFixed(1)} Oz`;

    console.log(`Total price of all selected options: $${totalPrice.toFixed(2)}`);
    console.log(`Total Calories: ${totalCalories}, Protein: ${totalProtein}, Fat: ${totalFat}, Carbs: ${totalCarbs}`);
    console.log(`Total Quantity: ${totalQuantity.toFixed(1)} Oz`);
  });
});





    document.querySelector('button.add-to-cart[type="submit"]').addEventListener('click', function(event) {

        if(!document.querySelector('button.add-to-cart[type="submit"]').classList.contains('success')) {

            event.preventDefault();
            event.stopPropagation();

            document.querySelector('.load-more').classList.add('active');
        
            const visibleSelectFields = Array.from(document.querySelectorAll('.line-item-property__field.cstm_chk select'))
                .filter(select => getComputedStyle(select.parentElement).display === 'block');
        
            let totalPrice = 0;
        
            visibleSelectFields.forEach(select => {
                const selectedOption = select.options[select.selectedIndex];
                const priceMatch = selectedOption.text.match(/\$([\d.]+)/);
                const price = priceMatch ? parseFloat(priceMatch[1]) : 0;
        
                console.log(`Price of selected option: $${price.toFixed(2)}`);
                totalPrice += price;
                
                const formattedEntry = `${selectedOption.text.trim()}: $${price.toFixed(2)}`;
            });
        
            console.log(`Total price of all selected options: $${totalPrice.toFixed(2)}`);
            let productPrice = Number(document.querySelector('.product-price .product-price--original').getAttribute('data-product-price'));
        
            if (totalPrice >= 0) {
    
                const apiUrl = 'https://heat-custom-meal-pricing-api.vercel.app/api/custom-api';
            
                const data = {
                    price: totalPrice + productPrice
                };
            
                fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                })
                .then(async response => {
                    console.log('Response status:', response.status);
                    console.log('Response status text:', response.statusText);
            
                    if (!response.ok) {
                        const errorText = await response.text(); // Get full error text
                        throw new Error(`Network response was not ok. Status: ${response.status}. Message: ${errorText}`);
                    }
            
                    return response.json();
                })
                .then(data => {
                    console.log('Success:', data);
                  
                    const productId = 44381833265252;
                    document.querySelector('product-form .form input[name="id"]').value = productId;
                    const lineItemProperties = {};
                    const productForm = document.querySelector('product-form .form');
                    
                    // Helper function to create hidden input elements
                    function createHiddenInput(name, value) {
                      const input = document.createElement('input');
                      input.type = 'hidden';
                      input.name = `properties[${name}]`;
                      input.value = value;
                      return input;
                    }
                    
                    // Protein line item
                    const proteinElement = document.getElementById('protein');
                    const proteinActive = proteinElement ? proteinElement.value : null;
                    const proteinActivePriceElement = document.querySelector('.protein-options .line-item-property__field.cstm_chk[style="display: block;"] select');
                    const proteinActivePrice = proteinActivePriceElement ? proteinActivePriceElement.value : null;
                    
                    if (proteinActive && proteinActive !== 'Select Protein' && proteinActivePrice) {
                      lineItemProperties["Protein"] = `${proteinActive} - ${proteinActivePrice}`;
                      // Create hidden input and append to the product form
                      const proteinInput = createHiddenInput("Protein", `${proteinActive} - ${proteinActivePrice}`);
                      productForm.appendChild(proteinInput);
                    }
                    
                    // Carbohydrates line item
                    const carbElement = document.getElementById('carbohydrates');
                    const carbActive = carbElement ? carbElement.value : null;
                    const carbActivePriceElement = document.querySelector('.carbohydrate-options .line-item-property__field.cstm_chk[style="display: block;"] select');
                    const carbActivePrice = carbActivePriceElement ? carbActivePriceElement.value : null;
                    
                    if (carbActive && carbActive !== 'Select Carbs' && carbActivePrice) {
                      lineItemProperties["Carbohydrates"] = `${carbActive} - ${carbActivePrice}`;
                      // Create hidden input and append to the product form
                      const carbInput = createHiddenInput("Carbohydrates", `${carbActive} - ${carbActivePrice}`);
                      productForm.appendChild(carbInput);
                    }
                    
                    // Vegetables line item
                    const veggElement = document.getElementById('vegetable');
                    const veggActive = veggElement ? veggElement.value : null;
                    const veggActivePriceElement = document.querySelector('.vegetable-options .line-item-property__field.cstm_chk[style="display: block;"] select');
                    const veggActivePrice = veggActivePriceElement ? veggActivePriceElement.value : null;
                    
                    if (veggActive && veggActive !== 'Select Vegetable' && veggActivePrice) {
                      lineItemProperties["Vegetables"] = `${veggActive} - ${veggActivePrice}`;
                      // Create hidden input and append to the product form
                      const veggInput = createHiddenInput("Vegetables", `${veggActive} - ${veggActivePrice}`);
                      productForm.appendChild(veggInput);
                    }

                    document.querySelector('button.add-to-cart[type="submit"]').classList.add('success');
                    document.querySelector('.load-more').classList.remove('active');
                    document.querySelector('button.add-to-cart[type="submit"]').click();

                    document.querySelectorAll('.line-item-property__field select').forEach(select => {
                      select.selectedIndex = 0;
                    });
        
                    const data2 = {
                        id: productId,
                        quantity: 1,
                        properties: lineItemProperties
                    };
            
                    // AJAX request to add to cart
                    // fetch('/cart/add.js', {
                    //     method: 'POST',
                    //     headers: {
                    //         'Content-Type': 'application/json',
                    //         'Accept': 'application/json'
                    //     },
                    //     body: JSON.stringify(data2)
                    // })
                    // .then(response => {
                    //     if (!response.ok) {
                    //         throw new Error('Network response was not ok');
                    //     }
                    //     return response.json();
                    // })
                    // .then(cart => {
                    //     console.log('Product added to cart:', cart);
                    //     document.querySelector('button.add-to-cart[type="submit"]').classList.add('success');
                    //     document.querySelector('.load-more').classList.remove('active');
                    //     document.querySelector('button.add-to-cart[type="submit"]').click();
                    // })
                    // .catch(error => {
                    //     console.error('There was a problem with the fetch operation:', error);
                    // });
                })
                .catch((error) => {
    console.error('Error caught:', error);
    document.querySelector('.load-more')?.classList.remove('active');
});
    
            }
          
        } else {

            document.querySelector('button.add-to-cart[type="submit"]').classList.remove('success');
          
        }
      
    });

  }
  
});






